<template lang="pug">
v-card.quickaccess-card.secondary.px-4.py-3.d-flex.flex-column.justify-space-between(
  :to="to",
  :href="href",
  :width="small ? '125px' : '150px'",
  height="90px",
  flat
)
  v-img(:src="img", width="30px", max-height="30px", contain)
  .quickaccess-card-title.text-caption.text-uppercase.font-weight-black {{ title }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    href() {
      if (!this.link) return;

      return new URL(this.server).host !== new URL(this.link).host
        ? this.link
        : null;
    },
    to() {
      if (!this.link) return;

      const URLServer = new URL(this.server);
      const URLLink = new URL(this.link);

      return URLServer.host === URLLink.host ? URLLink.pathname : null;
    },
  },
};
</script>

<style>
.quickaccess-card {
  gap: 8px;
}
.quickaccess-card-title {
  line-height: 14px !important;
}
</style>
